var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWizardIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.175 2.33317H2.59165V17.6665H16.0083V6.1665H12.175V2.33317ZM0.674988 1.36698C0.674988 0.842052 1.10383 0.416504 1.63188 0.416504H13.1333L17.9247 5.20817L17.925 18.6177C17.925 19.1509 17.4986 19.5832 16.973 19.5832H1.627C1.10122 19.5832 0.674988 19.1468 0.674988 18.6327V1.36698ZM8.34165 9.0415H10.2583V14.7915H8.34165V9.0415ZM8.34165 5.20817H10.2583V7.12484H8.34165V5.20817Z",
    fill: "#6B7385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardIcon02);
export default __webpack_public_path__ + "static/media/wizard-icon-02.c5bf00ee185f2edd7e3f4095d09c143e.svg";
export { ForwardRef as ReactComponent };